module.exports = __webpack_public_path__ + "resources/img/img_credit_event2_v2.fb909a3a0ac046354530a2a56c4262dc.png";